import { Controller } from "@hotwired/stimulus"

// "Ask <name>" for a viewer who can't chat with the twin (_ask_thread): each
// question asked - a chip here, or a question in the page's Ask list, which
// opens the chat panel first - shows as a chat exchange: the question, then
// the owner's saved answer, and plays the recording on the avatar when there
// is one. Nothing leaves the page.
export default class extends Controller {
  static targets = ["thread"]

  ask(event) {
    this._ask(event.currentTarget)
  }

  // A question in the page's Ask list (data-ask-question): its own click
  // opened the chat panel (profile-chat-panel#open); this adds the exchange.
  fromPage(event) {
    const question = event.target.closest?.("[data-ask-question]")
    if (!question || this.element.contains(question)) return
    this._ask(question)
  }

  _ask(source) {
    const { askQuestion, askAnswer, askAnswerId } = source.dataset
    if (!askQuestion || !askAnswer) return
    this.threadTarget.append(this._bubble("user", askQuestion), this._bubble("assistant", askAnswer))
    this.element.querySelectorAll("[data-ask-question]").forEach((chip) => {
      if (chip.dataset.askQuestion === askQuestion) chip.classList.add("is-asked")
    })
    requestAnimationFrame(() => this.threadTarget.lastElementChild?.scrollIntoView({ block: "nearest" }))
    const id = Number(askAnswerId)
    if (!id) return
    const host = document.querySelector("[data-controller~='profile-stage']")
    const stage = host && this.application.getControllerForElementAndIdentifier(host, "profile-stage")
    stage?.ask({ preventDefault() {}, params: { id }, currentTarget: source })
  }

  // The Jane chat's bubble (assistants/_turns): the asker's on the right,
  // the owner's answer on the left.
  _bubble(side, text) {
    const bubble = document.createElement("div")
    bubble.className = `assistant-bubble assistant-bubble-${side}`
    bubble.textContent = text
    return bubble
  }
}
